import { JsonProperty, Serializable } from 'ts-jackson'

@Serializable()
export class AutoBanSettings {
  @JsonProperty('enabled') enabled: boolean = false
  @JsonProperty('absenceThreshold') absenceThreshold: number = 3
  @JsonProperty('banDurationDays') banDurationDays: number = 7
  @JsonProperty('updatedAt') updatedAt: string = ''
}

export interface UpdateAutoBanSettingsPayload {
  enabled: boolean
  absenceThreshold: number
  banDurationDays: number
}

@Serializable()
export class MemberNoShowStatus {
  @JsonProperty('enabled') enabled: boolean = false
  @JsonProperty('absenceCount') absenceCount: number = 0
  @JsonProperty('absenceThreshold') absenceThreshold: number = 3
  @JsonProperty('periodYear') periodYear: number = 0
  @JsonProperty('periodMonth') periodMonth: number = 0
  @JsonProperty('bannedThisMonth') bannedThisMonth: boolean = false
  /** Late class cancels recorded in the same window. */
  @JsonProperty('lateCancelCount') lateCancelCount: number = 0
  /**
   * Whether those late cancels are part of `absenceCount` — i.e. whether the
   * club's late-cancel policy is STRIKE with "counts as an absence" on. When
   * false they are shown for context only and must not be added to the count.
   */
  @JsonProperty('lateCancelCountsAsAbsence') lateCancelCountsAsAbsence: boolean = false
}
